<template>
	<div>
		<Header>
			<div class="leftcss"><a @click='goBack'><i class="iconfont icon---"></i></a></div>
			<div class="centercss">关于本站</div>
		</Header>
		<div class="body-main">
			<p>网站所用的源文件是从byscrj.com上下载的。是DJVU文件。我本想把文件转换成txt文档录入，后来发现网上现成的文档，就直接搬过来用。大部分内容来自于daotext.org和wenxian.fanren8.com。但是从网上搜集的内容有错误，而且大部分错误都是一样的，所以不能对比校对，只能人工校对。（byscrj.com和wenxian.fanren8.com现在分别改名为www.homeinmists.com和122.200.75.13）</p>
			<p>校验的过程就是根据《中华道藏》DJVU版校对，边看边改，发现错误就改。所以会很慢。校对过的道经会在内容页面标题左侧出现“已校对”或“校对一次”。</p>
			<p>校对中的一些情况说明：</p>
			<p>1.原书中资料不全的地方用方框□代替，但是网页中使用□很容易和“口”字混淆，所以网页上用◇代替了原书中的□。比如原经中是“散思候□常”，其中的□是方框，很容易和“口”字混淆，所以就用◇代替，写成“散思候◇常”。</p>
			<p>2.经中很多字在现有的网络版本中被替换成同义字，比如原文书中的“呪”字，网络版本多以“咒”代替。比如“籙”字，基本用“箓”代替。这些字基本不会更改。网络版本写成咒，就用咒，写成呪，就用呪。基本不改动了。</p>
			<p>我的QQ: 5360 4810</p>
			<p><a href="https://www.daorenjia.com/jd/sm.php" target="_blank">帮助校对</a></p>
						<p><a href="https://pan.baidu.com/s/1DAJP8UGlJDMnZzA7dkdYaQ?pwd=1uj6">中华道藏百度网盘下载地址：https://pan.baidu.com/s/1DAJP8UGlJDMnZzA7dkdYaQ?pwd=1uj6</a></p>
						<p>提取码: 1uj6</p>

			
			</br></br>
		</div>

	</div>
</template>
<script>
	import Header from '@/components/Header.vue'
	export default {
		components: {
			Header,
			},
			methods: {
				goBack() {
					window.history.length > 1 ?
						this.$router.go(-1) :
						this.$router.push('/')
				}
			},
		
		}
</script>
 